export const MICROSOFT_INTEGRATION = {
  TITLE: 'Connect your Microsoft 365 tenant',
  STEP1: {
    DESCRIPTION: 'Enter your Microsoft Entra tenant ID to begin the connection process.',
    INPUT_LABEL: 'Microsoft Entra tenant ID',
    INPUT_HELP_LINK: 'Where do I find this?',
    INPUT_ERROR: 'Please enter your tenant ID',
    PERMISSIONS_DISCLAIMER: 'Account must have Directory read permissions or Admin privileges.',
  },
  STEP2: {
    DESCRIPTION: "Verify the ID below. You'll be redirected to Microsoft to grant read-only access.",
  },
  FOOTER: {
    CANCEL: 'Cancel',
    CONTINUE: 'Continue',
    BACK: 'Back',
    OPEN_EXTERNAL: 'Open Microsoft 365',
  },
  STEP_PROGRESS: {
    STEP_1: 'Step 1: Tenant Details',
    STEP_2: 'Step 2: Review & Consent',
  },
}
